<script setup lang="ts">
definePageMeta({
  layout: 'blank',
});

const route = useRoute();
const { modalType, authInitialTab } = storeToRefs(useLayoutStore());
const { closeModal } = useLayoutStore();
const { getSecureQueryParam } = useRoutes();

const closeModalOrGoToHome = () => {
  if (window.self !== window.top) {
    closeModal();
    window.parent.postMessage('closeModal');

    return;
  }

  navigateTo(localeLink('/'));
};

onMounted(() => {
  modalType.value = 'login';

  const tabFromQuery =
    route.query.tab && typeof route.query.tab === 'string'
      ? getSecureQueryParam(route.query.tab)
      : '';

  if (tabFromQuery === 'register') {
    authInitialTab.value = 'register';
  }

  window.parent.postMessage('iframeReady');
});
</script>

<template>
  <AuthPageLayout @action-to-close="closeModalOrGoToHome">
    <!-- O compliance é renderizado dentro do AuthLogin (rodapé), pra cobrir as
         abas login/registro sem duplicar com o CompleteRegulatory. -->
    <AuthLogin />
  </AuthPageLayout>
</template>
